import React from "react";
const ThumbsDownIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width="14"
      height="14"
      xmlns="http://www.w3.org/2000/svg"
      ref={svgRef}
      {...props}
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M7 11.29C7 9.523 8.692 9.134 9.484 8.13c.487-.62.677-1.806.677-1.806V1.129C8.818.659 7.904 0 5.194 0 3.03.021 2.654.045 1.806.903.903 1.806 0 5.293 0 7.226c0 .15.04.322.08.514.198.934 1.401 1.129 2.404 1.129.718 0 1.401-.11 1.423-.11.214 0 .315.299.226.527-.266.684-.294 1.755-.294 2.908C3.839 14 5.419 14 5.419 14S7 14 7 11.29Z"
          fill="#FFD60B"
        />
        <path
          d="M9.878 1.237 8.362.452 5.797.112H3.812l-1.61.822L.733 5.04v1.477c.558-2.76 1.498-4.33 2.818-4.71 1.32-.38 3.408-.145 6.265.702l.062-1.271Z"
          fill="#FFB000"
        />
        <path
          d="M9.484 7.527 7.825 8.943l-.967 1.495-.365 2.419-1.188.802-1.088-.525.14-1.328c.231.748.577 1.001 1.037.759.69-.364-.198-3.188 1.653-4.131 1.851-.943 2.83-3.42 2.83-4.836v3.004l-.393.925Z"
          fill="#FFEB97"
        />
        <path
          d="M5.43 13.66c-.155-.007-.614-.055-.932-.425-.19-.22-.32-.553-.32-1.041 0-1.103.015-2.13.27-2.785-.518-.815-1.092-.876-1.713-.88h-.251c-.518 0-1.098-.049-1.534-.254-.256-.12-.462-.297-.532-.579-.069-2.345.761-5.687 1.63-6.555C2.834.344 3.203.358 5.193.34c2.083 0 3.072.401 4.04.795.195.079.388.157.589.232v4.93c-.029.168-.202 1.11-.606 1.624-.213.27-.499.49-.794.71-1.074.8-1.762 1.446-1.762 2.66 0 .815-.148 1.364-.36 1.73-.31.539-.758.63-.87.64Z"
          stroke="#975F00"
          strokeWidth=".677"
        />
        <rect
          stroke="#975F00"
          strokeWidth=".677"
          fill="#FFF"
          transform="rotate(180 11.742 4)"
          x="9.823"
          y=".339"
          width="3.839"
          height="7.323"
          rx="1.129"
        />
        <path
          d="M13.323 2.484a.452.452 0 0 0-.452-.452h-2.258a.452.452 0 0 0-.452.452V1.129c0-.25.202-.452.452-.452h2.258c.25 0 .452.203.452.452Z"
          fill="#CCC"
        />
      </g>
    </svg>
  )
);
ThumbsDownIcon.displayName = "ThumbsDownIcon";
export default ThumbsDownIcon;
